import React from "react";
import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const functions = [
  "Consider the sanction of teaching and non-teaching posts and recommend them to the Governing Body for approval.",
  "Get the financial approval of the Governing Body before implementing such decisions.",
  "Consider and approve the minutes of the selection committee for appointment of teaching and non-teaching posts.",
  "Propose a fee structure to the competent authority for various programs run by the University.",
  "Perform any other functions assigned by the Governing Body/Chancellor.",
];
const members = [
  [
    "Prof. (Dr) Anand Mahalwar",
    "Chairperson",
    "Vice Chancellor, ISBM University",
  ],
  [
    "Ms. Bindu Mahesh Agrawal",
    "Member",
    "Nominee, Sponsoring Body, ISBM University",
  ],
  [
    "Shri Jitendra Nahar",
    "Member",
    "Nominee, Sponsoring Body, ISBM University",
  ],
  ["Dr. Ashok Kumar Nema", "Member", "Nominee & Representative, State Govt."],
  ["Dr. C. L. Patel", "Member", "Nominee & Representative, State Govt."],
  [
    "Dr. N. Kumar Swamy",
    "Member",
    "Professor & Dean (Academics), ISBM University",
  ],
  [
    "Dr. Bhupendra Kumar",
    "Member",
    "Associate Professor & DSW, ISBM University",
  ],
  [
    "Dr. Garima Diwan",
    "Member",
    "Associate Prof. & HOD, Faculty of Arts & Humanities",
  ],
  [
    "Dr. Sohan Lal Sahu",
    "Member",
    "Asst. Professor & HOD, Faculty of Sciences",
  ],
  ["Dr. Barada Prasad Bhol", "Member Secretary", "Registrar, ISBM University"],
  ["Mr. David Mc Loughlin", "Adjunct Member", "Educationist, South London"],
  ["Mr. Ian Whitehead", "Adjunct Member", "Educationist, United Kingdom"],
];
export default function BoardOfManagement() {
  return (
    <>
      <MetaInfo param="" id="about" />
      <Header school="common" />
      <main>
        <section className="bg-burgundy pb-[150px] pt-[150px] text-white">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[.18em] text-gold">
              <span className="h-px w-12 bg-current" />
              University Management
            </div>
            <h1 className="mt-7 font-serif text-[clamp(50px,6.5vw,92px)] leading-[.96]">
              Board of Management
              <span className="block text-gold">governance in action.</span>
            </h1>
            <p className="mt-8 max-w-3xl text-lg leading-8 text-white/65">
              The Board of Management is a statutory body under the provisions
              of the Chhattisgarh Private Universities (Establishment and
              Operation) Act of 2005. The term of the nominated members of the
              Board of Management shall be of three years.
            </p>
          </div>
        </section>
        <section className="bg-[#EEF4F8] py-20 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <Eyebrow>Administrative Mandate</Eyebrow>
            <Title
              before="Managing"
              highlight="People, Resources"
              after="And University Operations"
              position="middle"
              theme="burgundy"
            />
            <div className="mt-14 grid gap-px bg-navy/10 lg:grid-cols-5">
              {functions.map((x, i) => (
                <article key={x} className="min-h-[280px] bg-white p-7">
                  <span className="font-serif text-3xl text-gold-dark">
                    0{i + 1}
                  </span>
                  <p className="mt-12 leading-7 text-ink/65">{x}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
        <section className="bg-white py-20 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <Eyebrow>Board Composition</Eyebrow>
            <Title
              before="The People Behind"
              highlight="Management Decisions"
              after=""
              position="middle"
              theme="burgundy"
            />
            <div className="mt-12 grid gap-px bg-navy/10 md:grid-cols-3">
              {members.map(([n, d, r], i) => (
                <article key={n} className="min-h-[190px] bg-[#F8FAFB] p-7">
                  <span className="text-xs font-bold text-gold-dark">
                    0{i + 1}
                  </span>
                  <h3 className="mt-7 font-serif text-2xl font-normal text-navy">
                    {n}
                  </h3>
                  <span className="mt-2 block text-xs font-bold uppercase text-burgundy">
                    {d}
                  </span>
                  <p className="mt-3 text-sm leading-6 text-ink/55">{r}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
